export default {
  ESAT_INIT: 'init',
  ESAT_SPIN: 'spin',
  ESAT_BUY: 'buy',
  ESAT_USE_BOMB: 'use_bomb',
}
